"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var camelToUnderscore = _modalLoaderUtils.HELPERS.camelToUnderscore;
var _default = exports.default = function _default(queryKey, envKey) {
  if (typeof window === 'undefined') return '';
  var url = new URL(window.location.href);
  var version = url.searchParams.get(queryKey);
  if (!version && window.process && window.process.env) {
    var ENV_KEY = envKey || camelToUnderscore(queryKey);
    version = window.process.env[ENV_KEY];
  }
  return version;
};